import { useMemo } from 'react';
import t, { useIntl } from '@jetshop/intl';
import { useAppSettingsStore } from '../../appSettingsStore';

const descriptionKeys = ['details', 'size'];
// const shippingReturnsKey = 'shipping_returns';

const skorKeys = [
  'lining',
  'upper_',
  'insole',
  'outsole',
  'shaft',
  'care_instructions'
];
const kladerAndAccKeys = [
  'sizeguide_fit',
  'material',
  'lining',
  'padding',
  'soommar',
  'closening',
  'fabricwatercolumnpressure',
  'care_instructions'
];
const vaskorKeys = [
  'measurements',
  'volume',
  'bag_volume',
  'computerpocket',
  'closening',
  'material',
  'lining',
  'soommar',
  'care_instructions'
];

const customFieldsKeys = {
  skor: skorKeys,
  klader: kladerAndAccKeys,
  acc: kladerAndAccKeys,
  vaskor: vaskorKeys
};

function getDescriptionList(customFields, articleNumber) {
  // Forming description list
  const descriptionList = [];
  const descriptionFields = customFields.filter(({ key }) =>
    descriptionKeys.includes(key)
  );
  descriptionFields.forEach(({ title, stringValue, key }) =>
    descriptionList.push({
      name: title,
      value: key === 'size' ? stringValue.replace('_', '/') : stringValue
    })
  );

  descriptionList.push({
    name: t('Article no'),
    value: articleNumber
  });

  return descriptionList;
}

function getSpecificationList(customFields, excludeList, yesIntlString) {
  // Forming specifications list
  const specificationList = [];
  const specificationFields = customFields.filter(
    ({ key }) => !excludeList?.includes(key)
  );
  specificationFields.forEach(({ title, stringValue, type, boolValue }) => {
    if (type === 'BOOL' && !boolValue) return;
    specificationList.push({
      name: title,
      value: type === 'BOOL' ? yesIntlString : stringValue ?? ''
    });
  });

  return specificationList;
}

// function getShippingReturns(customFields) {
//   // Forming shipping info
//   const shippingField = customFields.find(
//     ({ key }) => key === shippingReturnsKey
//   );
//   const shippingReturns = shippingField?.stringValue || '';

//   return shippingReturns;
// }

const useFormCustomInfo = product => {
  const pdpSpecExcludeList = useAppSettingsStore(
    state => state.pdpSpecExcludeList
  );
  const t = useIntl();
  const { customFields, articleNumber } = product;

  const { descriptionList, specificationList } = useMemo(() => {
    const descriptionList = getDescriptionList(customFields, articleNumber);
    const specificationList = getSpecificationList(
      customFields,
      pdpSpecExcludeList,
      t('yes')
    );

    return {
      descriptionList,
      specificationList
    };
  }, [customFields, articleNumber, pdpSpecExcludeList]);

  return { descriptionList, specificationList };
};

export default useFormCustomInfo;
